import fetch from '@/utils/fetch'

/**
 * 获取我的积分
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getCredit(data = {}) {
  return fetch({
    url: '/api_zaiart/service/zaiart/aw/mul/ow/credit/my',
    method: 'post',
    data
  })
}
/**
 * 奖品列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getPrizeList(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/lottery/item/list',
    method: 'post',
    data
  })
}

/**
 * 抽奖
 *
 * @export
 * @param {any} data
 * @returns
 */
export function lottery(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/lottery',
    method: 'post',
    data
  })
}

/**
 * 中奖用户
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getPrizeUserList(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/lottery/lately/prize/list',
    method: 'post',
    data
  })
}

/**
 * 我的奖品列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getMyPrizeList(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/lottery/my/prize/list',
    method: 'post',
    data
  })
}

/**
 * 抽奖分享回调
 *
 * @export
 * @param {any} data
 * @returns
 */
export function creditShare(data = {}) {
  return fetch({
    url: '/api_zaiart/service/zaiart/aw/mul/ow/credit/share',
    method: 'post',
    data
  })
}
